
import { Injectable } from '@angular/core';
import { Case } from '../../classes/Case';
import { CaseAddresses } from 'src/app/ordering-platform/classes/caseAddresses';
import { Order, OrderDetail } from 'src/app/ordering-platform/classes/Order';
import { DatePipe } from '@angular/common';

@Injectable({
    providedIn: 'root'
})

export class CaseFileHelper {
    public getTotal(caseSelected) {
        let totalamount = 0;
        let noAmount;
        if (!caseSelected.orders && !caseSelected.lines) {
            noAmount = 'No Price';
        } else if (caseSelected.lines && !caseSelected.orders) {
            for (let i = 0; caseSelected.lines.length > i; i++) {
                for (let a = 0; caseSelected.lines[i].lineDetails.length > a; a++) {
                    totalamount = totalamount + caseSelected.lines[i].lineDetails[a].totalgrossprice;
                }
            }
        } else {
            for (let i = 0; caseSelected.orders?.length > i; i++) {
                for (let a = 0; caseSelected.orders[i].orderdetails?.length > a; a++) {
                    totalamount = totalamount + caseSelected.orders[i].orderdetails[a].totalgrossprice;
                }
            }
        }
        if (noAmount === 'No Price') {
            return 0;
        } else {
            const amount = totalamount;
            return amount;
        }

    }
   // TODO: Refactor this method later
    public setInnerHTML(status: any) {

        let innerHtml;
        if (!status.orders && !status.lines) {
            innerHtml = 'NO DETAILS';
        } else if (status.lineDetails) {
            innerHtml = 'DRAFT';
        } else if (status.orderdetails) {
            if (status.length > 1) {
                let complete = 0;
                const totalOrders = status.length;
                const orderstatuses = [];
                for (let i = 0; status.length > i; i++) {
                    if (status[i].orderstatus === 6) {
                        complete = complete + 1;
                    } else {
                        orderstatuses.push(status[i].orderstatus);
                    }
                }
                if (complete === totalOrders) {
                    status = 6;
                } else if (orderstatuses.length > 1) {
                    // usage example:
                    const a = orderstatuses;
                    const unique = a.filter(this.onlyUnique);
                    if (unique.length === 1) {

                        status = unique[0];
                    } else {
                        status = 5;
                    }
                }
            } else {
                if (!parseInt(status)) {
                    status = status.orderstatus;
                }
            }
            innerHtml = this.getStatus(status);
        } else if (status.lines && !status.orders) {
   
            innerHtml = 'DRAFT';
        } else {
     
            if (status.orders.length > 1) {
                let complete = 0;
                const totalOrders = status.orders.length;
                const orderstatuses = [];
                for (let i = 0; status.orders.length > i; i++) {
                    if (status.orders[i].orderStatus === 6) {
                        complete = complete + 1;
                    } else {
                        orderstatuses.push(status.orders[i].orderStatus);
                    }
                }
                if (complete === totalOrders) {
                    status = 6;
                } else if (orderstatuses.length >= 1) {
                    // usage example:

                    const a = orderstatuses;
                    const unique = a.filter(this.onlyUnique);
                    if (unique.length === 1) {

                        status = unique[0];
                    } else {
                        status = 5;
                    }
                }
            } else {

                if (!parseInt(status.orders)) {
                    status = status.orders[0]?.orderStatus;
                }
            }
            innerHtml = this.getStatus(status);
        }
        return innerHtml;

    }

    Get24HourDate(_date: string | Date): string | Date {
        const pipe = new DatePipe('en-GB');
        const dateObj = new Date(_date);
        if (dateObj) {
            const minutes = dateObj.getMinutes();
            let newMinutes;
            if (minutes < 10) {
                newMinutes = `0${minutes}`;
            } else {
                newMinutes = minutes;
            }

            const timeString = dateObj.getHours() + ':' + newMinutes;
            const dateString = pipe.transform(dateObj, 'dd MMM yyyy') + ' ' + timeString;

            return dateString;
        }
    }

    // if returns true disables button
    CanCaseBeAddedToo(_currentCase: Case): boolean {
        if (_currentCase) {
            if (_currentCase.productSummary) {
                if (!_currentCase.productSummary.hasInsurance && !_currentCase.productSummary.has_searches) {
                    return true;
                }
            }
            return false;
        }
    }

    formatCaseAddressFromAddress(caseAddress: CaseAddresses) {

        if (caseAddress) {
            let address;
            if (caseAddress.buildingname) {
                caseAddress.buildingname = this.capitalizeFirstLetter(caseAddress.buildingname);
            } else {
                address = '';
            }
            if (caseAddress.subbuildingname) {
                caseAddress.subbuildingname = this.capitalizeFirstLetter(caseAddress.subbuildingname);
            }
            if (caseAddress.buildingnumber) {
                caseAddress.buildingnumber = this.capitalizeFirstLetter(caseAddress.buildingnumber);
            }
            if (caseAddress.organisation) {
                caseAddress.organisation = this.capitalizeFirstLetter(caseAddress.organisation);
            }
            if (caseAddress.buildingIdentifier) {
                caseAddress.buildingIdentifier = this.capitalizeFirstLetter(caseAddress.buildingIdentifier);
            }
            if (caseAddress.street) {
                caseAddress.street = this.capitalizeFirstLetter(caseAddress.street);
            } else if (caseAddress.thoroughfare) {
                caseAddress.thoroughfare = this.capitalizeFirstLetter(caseAddress.thoroughfare);
            }
            if (caseAddress.town) {
                caseAddress.town = this.capitalizeFirstLetter(caseAddress.town);
            }
            if (caseAddress.locality) {
                caseAddress.locality = this.capitalizeFirstLetter(caseAddress.locality);
            }
            if (caseAddress.towncity) {
                caseAddress.towncity = this.capitalizeFirstLetter(caseAddress.towncity);
            }
            if (caseAddress.county) {
                caseAddress.county = this.capitalizeFirstLetter(caseAddress.county);
            }
            if (caseAddress.postcode) {
                caseAddress.postcode = caseAddress.postcode.toUpperCase();
            }

            return caseAddress;
        }
        return;
    }

    public getStatus(status, bespokeLine?: boolean) {
        let innerHtml;
  
        if (bespokeLine) {
            switch (status) {
                case 0:
                    innerHtml = 'Pending';
                    break;
                case 2:
                    innerHtml = 'Cancelled';
                    break;
                case 14:
                    innerHtml = 'Awaiting Approval';
                    break;
                case 15:
                    innerHtml = 'Policy has been sold';
                    break;
                case 16:
                    innerHtml = 'Quote In Progress';
                    break;
                case 17:
                    innerHtml = 'Quote in progress/inactive';
                    break;
                case 18:
                    innerHtml = 'Quote provided';
                    break;
                case 19:
                    innerHtml = 'In progress - additional information requested';
                    break;
                case 20:
                    innerHtml = 'Case in triage';
                    break;
                case 21:
                    innerHtml = 'Case is with an underwriter';
                    break;
                case 22:
                    innerHtml = 'Closed';
                    break;
            }
        } else {

            switch (status) {
                case null:
                    innerHtml = 'No Status';
                    break;
                case 0: 
                    innerHtml = 'Pending';
                    break;
                case 1:
                    innerHtml = 'Failed';
                    break;
                case 2:
                    innerHtml = 'Cancelled';
                    break;
                case 3:
                    innerHtml = 'ManualStep';
                    break;
                case 4:
                    innerHtml = 'Rejected';
                    break;
                case 5:
                    innerHtml = 'Processing';
                    break;
                case 6:
                    innerHtml = 'Complete';
                    break;
                case 7:
                    innerHtml = 'CancelationRequested';
                    break;
                case 8:
                    innerHtml = 'Failed';
                    break;
                case 9:
                    innerHtml = 'Placed';
                    break;
                case 10:
                    innerHtml = 'Failed';
                    break;
                case 11:
                    innerHtml = 'CancelledInFlight';
                    break;
                case 12:
                    innerHtml = 'Created';
                    break;
                case 13:
                    innerHtml = 'Draft';
                    break;
                case 14:
                    innerHtml = 'Awaiting Approval';
                    break;
            }
        }
    
        return innerHtml;
    }

    private static readonly statusMap: { [K: number]: string } = {
        0: 'Pending',
        1: 'Failed',
        2: 'Cancelled',
        3: 'Placed',
        4: 'Rejected',
        5: 'Processing',
        6: 'Complete',
        7: 'Cancellation Requested',
        8: 'Failed',
        9: 'ManualStep',
        10: 'Failed',
        11: 'CancelledInFlight',
        12: 'Created',
        13: 'Draft',
        14: 'Awaiting Approval'
    }
    
    private static readonly detailStatusMap: { [K: number]: string } = {
        0: 'Pending',
        1: 'Complete',
        2: 'Cancelled',
        3: 'Placed',
        4: 'Rejected',
        5: 'Processing',
        6: 'Complete',
        7: 'Cancellation Requested',
        8: 'Failed',
        9: 'ManualStep',
        10: 'Failed',
        11: 'CancelledInFlight',
        12: 'Created',
        13: 'Draft',
        14: 'Awaiting Approval'
    }

    private static readonly bespokeStatusMap: { [K: number]: string } = {
        0: 'Pending',
        2: 'Cancelled',
        14: 'Awaiting Approval',
        15: 'Policy has been sold',
        16: 'Quote In Progress',
        17: 'Quote in progress/inactive',
        18: 'Quote provided',
        19: 'In progress - additional information requested',
        20: 'Case in triage',
        21: 'Case is with an underwriter',
        22: 'Closed'
    }

    private static readonly interventionStatusMap: { [K: number]: string } = {
        0: 'Pending',
        1: 'Cancellation Requested',
        2: 'Cancellation Requested',
        3: 'Cancellation Requested',
        4: 'Rejected',
        5: 'Rejected',
        6: 'Cancelled',
        7: 'Cancellation Requested',
        8: 'Failed',
        9: 'Placed',
        10: 'Cancelled',
        11: 'CancelledInFlight',
        12: 'Created',
        13: 'Draft',
        14: 'Awaiting Approval',
        16: 'Awaiting Bond'
    }

    public getStatusText(status: number | null, detailStatus?: number, bespokeLine?: boolean, interventionStatus?: number | null, cancellationState?: number): string {
        if (cancellationState && cancellationState > 0) {
            return CaseFileHelper.interventionStatusMap[cancellationState] || '';
        } else if (!cancellationState && interventionStatus === 16) {
            return CaseFileHelper.interventionStatusMap[interventionStatus] || '';
        } else if (bespokeLine) {
            return CaseFileHelper.bespokeStatusMap[status] || '';
        } else if (detailStatus) {
            return CaseFileHelper.detailStatusMap[detailStatus] || ''; 
        }
        else {
            return CaseFileHelper.statusMap[status] || '';
        }
    }

    public getStatusFromWord(status) {
        let innerHtml;
        switch (status) {
            case 'No Status':
                innerHtml = null;
                break;
            case 'null':
            case 'Pending':
                innerHtml = 0;
                break;
            case 'Failed':
                innerHtml = 1;
                break;
            case 'Cancelled':
                innerHtml = 2;
                break;
            case 'ManualStep':
                innerHtml = 3;
                break;
            case 'Rejected':
                innerHtml = 4;
                break;
            case 'Processing':
                innerHtml = 5;
                break;
            case 'Complete':
                innerHtml = 6;
                break;
            case 'CancelationRequested':
                innerHtml = 7;
                break;
            case 'FailedToPlace':
                innerHtml = 8;
                break;
            case 'Placed':
                innerHtml = 9;
                break;
            case 'FailedPostProcessing':
                innerHtml = 10;
                break;
            case 'CancelledInFlight':
                innerHtml = 11;
                break;
            case 'Created':
                innerHtml = 12;
                break;
            case 'ACTIVE':
                innerHtml = 13;
                break;
            case 'Draft':
                innerHtml = 15;
                break;
        }
        return innerHtml;
    }

    public getStatusFromWordForActiveFilters(status) {
        let innerHtml;
        switch (status) {
            case 'No Status':
                innerHtml = null;
                break;
            case 'null':
                innerHtml = [0];
                break;
            case 'Failed':
                innerHtml = [1, 8, 10];
                break;
            case 'Cancelled':
                innerHtml = [2, 4, 7, 11];
                break;
            case 'ManualStep':
                innerHtml = [3];
                break;
            case 'Rejected':
                innerHtml = [4];
                break;
            case 'Processing':
                innerHtml = [5];
                break;
            case 'Complete':
                innerHtml = [6];
                break;
            case 'CancelationRequested':
                innerHtml = [7];
                break;
            case 'FailedToPlace':
                innerHtml = [8];
                break;
            case 'Placed':
                innerHtml = [9];
                break;
            case 'FailedPostProcessing':
                innerHtml = [10];
                break;
            case 'CancelledInFlight':
                innerHtml = [11];
                break;
            case 'Created':
                innerHtml = [12];
                break;
            case 'ACTIVE':
                innerHtml = [13];
        }
        return innerHtml;
    }

    public getStatusColour(status: number | string, bespokeLine?: boolean, interventionStatus?: number | null, cancellationState?: number): string {
        if (cancellationState && cancellationState > 0) {
            return CaseFileHelper.cancellationColourMap[cancellationState];
        } else if (!cancellationState && interventionStatus === 16) {
            return CaseFileHelper.statusColourMap[interventionStatus];
        } else if (bespokeLine) {
            return CaseFileHelper.bespokeColourMap[status];
        } else {
            return CaseFileHelper.statusColourMap[status];
        }
    }

    static cancellationColourMap: { [key: number]: string } = {
        0: '#2B9A56',
        1: '#D81313',
        2: '#D81313',
        3: '#D81313',
        4: '#272727',
        5: '#2B9A56',
        6: '#D81313',
        7: '#D81313',
        8: '#D81313',
        9: '#2B9A56',
        10: '#D81313',
        11: '#272727',
        12: '#2B9A56',
        13: '#272727',
        14: 'orange'
    };

    static bespokeColourMap: { [key: number]: string } = {
        14: '#272727',
        15: '#272727',
        16: '#272727',
        17: '#272727',
        18: '#272727',
        19: '#272727',
        20: '#272727',
        21: '#272727',
        22: '#272727'
    };

    static statusColourMap: { [key: number]: string } = {
        0: '#272727',
        1: '#d81313',
        2: '#272727',
        3: '#2B9A56',
        4: '#272727',
        5: '#2B9A56',
        6: 'green',
        7: '#272727',
        8: '#d81313',
        9: 'orange',
        10: '#d81313',
        11: '#272727',
        12: '#2B9A56',
        13: '#272727',
        14: 'orange',
        15: '#D81313',
        16: '#2B9A56'
    };
    
    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    public style(status) {
        let style;
        switch (status) {

            case null:
                style = {
                    'color': '#272727',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 0:
                style = {
                    'color': '#272727',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 1:
                style = {
                    'color': '#d81313',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 2:
                style = {
                    'color': '#272727',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 3:
                style = {
                    'color': 'orange',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 4:
                style = {
                    'color': '#272727',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 5:
                style = {
                    'color': '#2B9A56',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 6: // complete
                style = {
                    'color': 'green',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 7:
                style = {
                    'color': '#272727',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 8:
                style = {
                    'color': '#d81313',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 9:
                style = {
                    'color': '#2B9A56',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',

                };
                break;
            case 10:
                style = {
                    'color': '#d81313',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 11:
                style = {
                    'color': '#272727',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 12:
                style = {
                    'color': '#2B9A56',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
            case 14:
                style = {
                    'color': 'orange',
                    'font-weight': 'bold',
                };
                break;
            case 15:
                style = {
                    'color': '#D81313',
                    'font-weight': 'bold',
                    'text-transform': 'uppercase',
                };
                break;
        }
        return style;
    }
    
    public transform(value: Date): string {
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        const valuedate = new Date(value);
        const currentmonth = valuedate.getMonth();
        const month = monthNames[currentmonth];
        const valuedatestringMM = this.dayMonthFormat(valuedate.getDate(), null) + '/' + this.dayMonthFormat(null, ((valuedate.getMonth()) + 1)) + '/' + valuedate.getFullYear();
        const valuedatestring = this.dayMonthFormat(valuedate.getDate(), null) + ' ' + month + ' ' + valuedate.getFullYear();
        const today = new Date();
        const todaystring = this.dayMonthFormat(today.getDate(), null) + '/' + this.dayMonthFormat(null, ((today.getMonth()) + 1)) + '/' + today.getFullYear();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        const yesterdaystring = this.dayMonthFormat(yesterday.getDate(), null) + '/' + this.dayMonthFormat(null, ((yesterday.getMonth()) + 1)) + '/' + yesterday.getFullYear();
        let newStr = '';

        if (valuedatestringMM === todaystring) {
            newStr = 'Today';
        } else if (valuedatestringMM === yesterdaystring) {
            newStr = 'Yesterday';
        } else {
            newStr = valuedatestring;
        }
        return newStr;
    }
    public dayMonthFormat(day: number, month: number): string {
        let date: string;
        if (day && month === null) {
            if (day < 10) {
                date = '0' + day;
            } else {
                date = day.toString();
            }
        } else if (month && day === null) {
            if (month < 10) {
                date = '0' + month;
            } else {
                date = month.toString();
            }
        }
        return date;
    }

    formatAddress(caseAddress: any) { 
        if (!caseAddress) {
            return;
        }

        const items1st = [
            // NOTE: "caseAddress.buildingIdentifier || caseAddress.organisation" is strange, 
            // but see strange remark in src\app\ordering-platform\components\address\address.component.ts:
            // "This component allows only the modification of organisation
            // If there is a building identifier move it to organisation and null it."
            this.capitalizeFirstLetter(caseAddress.buildingIdentifier || caseAddress.organisation),
            this.capitalizeFirstLetter(caseAddress.subbuildingname || caseAddress.subBuildingName),
            this.capitalizeFirstLetter(caseAddress.buildingname || caseAddress.buildingName),
            this.capitalizeFirstLetter((caseAddress.buildingnumber || caseAddress.buildingNumber)?.toString()),
        ].filter((x) => !!x).join(', ');

        const items2nd = [
            this.capitalizeFirstLetter(caseAddress.dependentthoroughfarename || caseAddress.dependentThoroughfareName),
            this.capitalizeFirstLetter(caseAddress.dependantthoroughfarename || caseAddress.dependantThoroughfareName),
            this.capitalizeFirstLetter(caseAddress.street ? caseAddress.street : caseAddress.thoroughfare),
            this.capitalizeFirstLetter(caseAddress.locality),
            this.capitalizeFirstLetter(caseAddress.town),
            this.capitalizeFirstLetter(caseAddress.towncity || caseAddress.townCity),
            this.capitalizeFirstLetter(caseAddress.county),
            caseAddress.postcode?.toUpperCase()
        ].filter((x) => !!x).join(', ');

        return [items1st, items2nd].filter((x) => !!x).join(' ');
    }
    static CapitalizeFirstLetter(str) {
        if (str) {
            str = str.toLowerCase().replace(/([^a-z])([a-z])(?=[a-z]{2})|^([a-z])/g, function (_, g1, g2, g3) {
                return (typeof g1 === 'undefined') ? g3.toUpperCase() : g1 + g2.toUpperCase();
            });
            return str;
        }
        return '';
    }

    capitalizeFirstLetter(str) {
        return CaseFileHelper.CapitalizeFirstLetter(str);
    }
}
